// FT-079: общий enrollment passkey — переиспользуется в Profile (настройки) и PasskeyNudge (подсказка).
// Behavior извлечён из Profile.vue 1:1 (те же эндпоинты, те же сообщения об ошибках).
import {
  isWebAuthnSupported,
  isNativeApp,
  isPlatformAuthenticatorAvailable,
  createCredential,
  detectDeviceName,
} from "@/utils/webauthn";
import { markEnrolledHere } from "@/utils/passkeyNudge";

export default {
  data() {
    return {
      passkeySupported: false,
      passkeyPlatformAvailable: false,
      passkeyRegistering: false,
    };
  },
  methods: {
    async checkPasskeySupport() {
      this.passkeySupported = isWebAuthnSupported() || isNativeApp();
      if (this.passkeySupported) {
        this.passkeyPlatformAvailable = await isPlatformAuthenticatorAvailable();
      }
    },
    // Регистрация passkey на текущем устройстве. true — успех, false — отмена/ошибка (notify внутри).
    // На успехе помечает enrolledHere → post-login nudge (FT-079) больше не показывается на этом девайсе.
    async enrollPasskey() {
      this.passkeyRegistering = true;
      const auth = { headers: { Authorization: this.$store.getters.getAuthToken } };
      try {
        const optionsResponse = await this.axios.post("/api/v1/passkeys/registration_options", {}, auth);
        let credentialData;
        try {
          credentialData = await createCredential(optionsResponse.data);
        } catch (credError) {
          this.notifyPasskeyEnrollError(credError, true);
          return false;
        }
        if (!credentialData) {
          this.$notify(this.$t("errors.attention"), this.$t("passkeys.cancelled"), "warning", 5000);
          return false;
        }
        await this.axios.post(
          "/api/v1/passkeys/register",
          { credential: credentialData, nickname: detectDeviceName() },
          auth
        );
        this.$notify(this.$t("passkeys.registered"), "", "success", 3000);
        markEnrolledHere(this.$store.getters.currentUserId);
        return true;
      } catch (error) {
        this.notifyPasskeyEnrollError(error, false);
        return false;
      } finally {
        this.passkeyRegistering = false;
      }
    },
    notifyPasskeyEnrollError(err, isCreate) {
      if (err && err.name === "NotAllowedError") {
        this.$notify(this.$t("errors.attention"), this.$t("passkeys.cancelled"), "warning", 5000);
      } else if (isCreate && err.name === "InvalidStateError") {
        // Аутентификатор уже содержит наш passkey (excludeCredentials) → это устройство уже покрыто.
        markEnrolledHere(this.$store.getters.currentUserId);
        this.$notify(this.$t("errors.attention"), this.$t("passkey_nudge.already_on_device"), "info", 6000);
      } else if (isCreate && (err.name === "OperationError" || (err.message && err.message.includes("Non-recoverable")))) {
        this.$notify(this.$t("errors.error"), this.$t("passkeys.registration_failed"), "error", 10000);
      } else if (isCreate && err.name === "SecurityError") {
        this.$notify(this.$t("errors.error"), this.$t("passkeys.passkey_registration_domain_error"), "error", 10000);
      } else {
        const msg =
          (err && err.response && err.response?.data && err.response?.data.error) ||
          `${(err && err.name) || "Error"}: ${(err && err.message) || err}`;
        this.$notify(this.$t("errors.error"), msg, "error", 10000);
      }
    },
  },
};
